/** @jsxImportSource @emotion/react */
import { memo } from 'react';
import { MenuItem, Select } from '@mui/material';
import { CustomFieldConditionValue } from '../typings';

interface Props {
  value: CustomFieldConditionValue;
  onChange: (next: CustomFieldConditionValue) => void;
}

const BooleanValueInput = ({ value, onChange }: Props) => {
  const current = value.type === 'VALUE' && typeof value.value === 'boolean' ? String(value.value) : '';
  return (
    <Select
      fullWidth
      size="small"
      displayEmpty
      value={current}
      onChange={(e) => onChange({ type: 'VALUE', value: e.target.value === 'true' })}
      sx={{ fontSize: 14 }}
    >
      <MenuItem value="" sx={{ fontSize: 14 }} disabled>
        Select value
      </MenuItem>
      <MenuItem value="true" sx={{ fontSize: 14 }}>
        True
      </MenuItem>
      <MenuItem value="false" sx={{ fontSize: 14 }}>
        False
      </MenuItem>
    </Select>
  );
};

export default memo(BooleanValueInput);
